export default function SecuritySection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
            <div>
              <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-3">
                Privacy First
              </span>
              <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-4">
                Your Spreadsheet Data Security Matters
              </h2>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                We respect your privacy completely. <strong>We do not store, access, or share any personal spreadsheet files or shopping records.</strong> Our website is an independent educational resource — your data stays entirely in your control.
              </p>

              <div className="space-y-3 mt-6">
                {[
                  { icon: 'ri-shield-check-line', text: 'HTTPS encryption for secure browsing' },
                  { icon: 'ri-eye-off-line', text: 'We never access your private spreadsheets' },
                  { icon: 'ri-lock-line', text: 'Privacy-first architecture — no data collection' },
                  { icon: 'ri-file-shield-line', text: 'Transparent policies — read them any time' },
                ].map((item) => (
                  <div key={item.text} className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                      <i className={`${item.icon} text-accent-600 text-sm`}></i>
                    </div>
                    <span className="text-sm text-foreground-700">{item.text}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="relative">
              <div className="aspect-square bg-background-100 rounded-lg border border-background-200/60 overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Minimalist%20warm%20cream%20abstract%20geometric%20composition%20with%20soft%20sage%20green%20accents%20representing%20digital%20security%20and%20data%20privacy%2C%20gentle%20overlapping%20translucent%20shapes%2C%20modern%20clean%20design%2C%20calm%20peaceful%20atmosphere%2C%20soft%20diffused%20lighting%2C%20editorial%20quality%20art%20piece%2C%20no%20text%20no%20logos%20no%20branding&width=800&height=800&seq=security-bg-v2-02&orientation=squarish"
                  alt="Data security and privacy protection"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}